import axios from 'axios'

export const HTTP = axios.create({
    baseURL: process.env.GATSBY_API_URL,
    headers: {
        'X-API-KEY': process.env.API_KEY
    }
})
